import React from 'react';
import { motion } from 'framer-motion';
export function CostComparison() {
  const costs = [{
    sin: '1 service innecesario por año',
    real: '$15.000–$30.000 que podrías haber evitado'
  }, {
    sin: 'Scooter parado 3 días por falla simple',
    real: 'Tu movilidad, tu tiempo, tu plata'
  }, {
    sin: 'Batería arruinada por malos hábitos de carga',
    real: 'Reemplazo: $25.000–$80.000 según modelo'
  }, {
    sin: 'Pinchazos frecuentes por presión incorrecta',
    real: 'Cámaras + tiempo + frustración'
  }, {
    sin: 'Pagar service sin entender qué te hicieron',
    real: 'Siempre vas a depender de otro'
  }, {
    sin: 'Comprar repuesto equivocado por no saber qué pedir',
    real: 'Plata tirada + demora'
  }];
  return <section className="py-20 px-4" data-id="element-37">
      <div className="max-w-4xl mx-auto" data-id="element-38">
        <div className="text-center mb-12" data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white" data-id="element-40">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="bg-surface border border-border rounded-2xl overflow-hidden mb-12" data-id="element-41">
          <table className="w-full border-collapse" data-id="element-42">
            <thead data-id="element-43">
              <tr className="bg-background border-b border-border" data-id="element-44">
                <th className="text-left py-4 px-6 text-white font-medium w-1/2" data-id="element-45">
                  Sin MegaPack
                </th>
                <th className="text-left py-4 px-6 text-danger font-medium w-1/2" data-id="element-46">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-47">
              {costs.map((row, idx) => <tr key={idx} className="border-b border-border/50 last:border-0 hover:bg-white/5 transition-colors" data-id="element-48">
                  <td className="py-4 px-6 text-gray-300" data-id="element-49">{row.sin}</td>
                  <td className="py-4 px-6 text-danger/90 font-medium" data-id="element-50">
                    {row.real}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center" data-id="element-51">
          <p className="text-xl text-muted mb-8" data-id="element-52">
            El próximo service puede ser el último innecesario.
          </p>
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block bg-brand/10 border border-brand/30 rounded-2xl p-8" data-id="element-53">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white italic" data-id="element-54">
              "El scooter que entendés dura el doble y te cuesta la mitad."{' '}
              <span className="not-italic" data-id="element-55">🛴</span>
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}